export default __webpack_public_path__ + "static/media/81.e2425fd1.svg";